import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/edit.png'
import _imports_1 from '@/assets/images/illustrations/spoon.png'
import _imports_2 from '@/assets/images/illustrations/warning.png'


const _hoisted_1 = {
  key: 0,
  class: "_create-boarding _modal bg-white",
  style: {"max-width":"720px"}
}
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Luca Education",
    height: "60",
    src: _imports_0,
    title: "Luca Education",
    width: "60"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }, " Trung tâm chưa thiết lập tính năng lớp bán trú ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-neutral-500 mt-2" }, " Bạn hãy thiết lập lớp bán trú và ngày giờ hoạt động để có thể sử dụng tính năng này ", -1)
const _hoisted_6 = { class: "mt-8 w-full" }
const _hoisted_7 = { class: "input-group flex-nowrap flex items-center justify-between mb-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 text-neutral-400 font-semibold" }, " Lớp bán trú ", -1)
const _hoisted_9 = { class: "input-group flex-nowrap flex items-center justify-between mb-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-1/2 text-neutral-400 font-semibold" }, " Giờ bắt đầu buổi học ", -1)
const _hoisted_11 = { class: "mb-10" }
const _hoisted_12 = { class: "input-group flex-nowrap flex items-center justify-between" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-1/2 text-neutral-400 font-semibold" }, " Giờ kết thúc buổi học ", -1)
const _hoisted_14 = { class: "flex items-center justify-end" }
const _hoisted_15 = {
  key: 0,
  class: "error text-sienna-600 text-sm"
}
const _hoisted_16 = { class: "input-group flex-nowrap flex items-center justify-between" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-1/2 text-neutral-500 font-normal" }, " Ngày nghỉ ", -1)
const _hoisted_18 = { class: "w-full md:w-1/2" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<option disabled selected value=\"\"> Chọn ngày nghỉ </option><option value=\"1\">Thứ 2</option><option value=\"2\">Thứ 3</option><option value=\"3\">Thứ 4</option><option value=\"4\">Thứ 5</option><option value=\"5\">Thứ 6</option><option value=\"6\">Thứ 7</option><option value=\"7\">Chủ nhật</option>", 8)
const _hoisted_27 = [
  _hoisted_19
]
const _hoisted_28 = { class: "input-group flex-nowrap flex items-center justify-between mb-10" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_30 = {
  key: 0,
  class: "p-4 mt-4 border border-neutral-100 rounded-xl w-full md:w-1/2"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Remove small option", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-2 w-2",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 8 8"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1l6 6m0-6L1 7",
    "stroke-linecap": "round",
    "stroke-width": "1.5"
  })
], -1)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "p-4 mt-4 border border-neutral-100 rounded-xl w-full md:w-1/2"
}
const _hoisted_36 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 1,
  class: "_create-boarding _modal bg-white",
  style: {"max-width":"720px"}
}
const _hoisted_39 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_40 = {
  key: 0,
  alt: "Luca Education",
  height: "60",
  src: _imports_1,
  title: "Luca Education",
  width: "60"
}
const _hoisted_41 = {
  key: 1,
  alt: "Luca Education",
  height: "60",
  src: _imports_2,
  title: "Luca Education",
  width: "60"
}
const _hoisted_42 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }
const _hoisted_43 = { class: "text-center text-neutral-500 mt-2" }
const _hoisted_44 = {
  key: 0,
  class: "w-full sm:px-8"
}
const _hoisted_45 = { class: "w-full mt-8" }
const _hoisted_46 = { class: "input-group flex flex-nowrap sm-down:flex-col items-start" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-400 text-xs font-semibold uppercase w-2/5 whitespace-nowrap mt-3.5" }, " Tên lớp bán trú ", -1)
const _hoisted_48 = {
  key: 0,
  class: "input-group flex items-center"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/5" }, null, -1)
const _hoisted_50 = { class: "mt-4 ml-4 w-full" }
const _hoisted_51 = { class: "error text-sienna-600 text-sm" }
const _hoisted_52 = {
  key: 0,
  class: "w-full mt-10"
}
const _hoisted_53 = { class: "flex flex-nowrap sm-down:flex-col items-start" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-400 text-xs font-semibold uppercase w-2/5 whitespace-nowrap mt-3.5" }, " Giáo viên ", -1)
const _hoisted_55 = { class: "w-full" }
const _hoisted_56 = {
  key: 0,
  class: "input-group flex items-center mb-4"
}
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  key: 1,
  class: "flex items-center mb-4"
}
const _hoisted_59 = {
  key: 1,
  class: "w-full mt-10"
}
const _hoisted_60 = { class: "input-group flex sm-down:flex-col flex-nowrap items-start" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-400 text-xs w-2/5 whitespace-nowrap uppercase font-semibold mt-3.5" }, " Ngày nghỉ ", -1)
const _hoisted_62 = { class: "w-full" }
const _hoisted_63 = { class: "w-full flex mb-4" }
const _hoisted_64 = { class: "input-group w-full" }
const _hoisted_65 = ["value"]
const _hoisted_66 = { class: "w-full grid md:flex gap-2 md-down:grid-cols-2" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = {
  key: 0,
  class: "ml-2 text-sm text-neutral-700 whitespace-nowrap"
}
const _hoisted_69 = {
  key: 1,
  class: "ml-2 text-sm text-neutral-700 whitespace-nowrap"
}
const _hoisted_70 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_VueDatepicker = _resolveComponent("VueDatepicker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.steps === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_SwitchButton, {
                  value: _ctx.turnOn,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.turnOn = !_ctx.turnOn))
                }, null, 8, ["value"])
              ]),
              (_ctx.turnOn)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_VueDatepicker, {
                        modelValue: _ctx.start_opening_hour_DayCare,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.start_opening_hour_DayCare) = $event)),
                        autoApply: "",
                        class: "input-date md:w-1/2 w-full",
                        minutesIncrement: "30",
                        placeholder: "Giờ bắt đầu buổi học",
                        timePicker: "",
                        uid: "start_opening_hour_DayCare"
                      }, {
                        "input-icon": _withCtx(() => [
                          _createVNode(_component_DaIcon, {
                            class: "h-4 w-4 text-neutral-400",
                            name: "das--lock"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createVNode(_component_VueDatepicker, {
                          modelValue: _ctx.end_opening_hour_DayCare,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.end_opening_hour_DayCare) = $event)),
                          autoApply: "",
                          class: "input-date md:w-1/2 w-full mb-2",
                          minutesIncrement: "30",
                          placeholder: "Giờ kết thúc buổi học",
                          timePicker: "",
                          uid: "end_opening_hour_DayCare"
                        }, {
                          "input-icon": _withCtx(() => [
                            _createVNode(_component_DaIcon, {
                              class: "h-4 w-4 text-neutral-400",
                              name: "das--lock"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        (_ctx.timeError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.timeError), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDayCare) = $event)),
                          class: "mt-1 block pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md input"
                        }, _hoisted_27, 512), [
                          [_vModelSelect, _ctx.selectedDayCare]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      (_ctx.daySelectedDayCare?.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daySelectedListDayCare, (d) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: d,
                                class: "inline-flex items-center py-0.5 pl-2 pr-0.5 rounded-full text-xs font-medium bg-blue-100 text-indigo-700 mr-1 shadow-input whitespace-nowrap"
                              }, [
                                _createTextVNode(_toDisplayString(d != 7 ? 'Thứ ' + (d + 1) : 'Chủ nhật') + " ", 1),
                                _createElementVNode("button", {
                                  class: "flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-400 hover:bg-neutral-200 hover:text-neutral-500 shadow-input",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.removeDayCare(d))
                                }, _hoisted_34, 8, _hoisted_31)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_35, " Không có ngày nghỉ "))
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("button", {
              class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
            }, " Thoát "),
            _createElementVNode("button", {
              disabled: 
					!_ctx.turnOn ||
					!_ctx.start_opening_hour_DayCare ||
					!_ctx.end_opening_hour_DayCare
				,
              class: "button-p text-center whitespace-nowrap",
              type: "button",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.setupCenter && _ctx.setupCenter(...args)))
            }, " Xác nhận ", 8, _hoisted_37)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.steps === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", null, [
              (_ctx.org_setting.allow_create_day_care_class)
                ? (_openBlock(), _createElementBlock("img", _hoisted_40))
                : (_openBlock(), _createElementBlock("img", _hoisted_41))
            ]),
            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.org_setting.allow_create_day_care_class
						? _ctx.title
						: 'Trung tâm chưa thiết lập tính năng lớp bán trú'), 1),
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.org_setting.allow_create_day_care_class
						? _ctx.description
						: 'Bạn cần thiết lập lớp bán trú và ngày giờ hoạt động để có thể sử dụng tính năng này'), 1),
            (_ctx.org_setting.allow_create_day_care_class)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.boarding.name) = $event)),
                        class: _normalizeClass([_ctx.error ? 'input--error' : '', "w-full"]),
                        placeholder: "Nhập tên lớp bán trú",
                        type: "text"
                      }, null, 2), [
                        [_vModelText, _ctx.boarding.name]
                      ])
                    ]),
                    (_ctx.error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.error), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.boardingData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("div", _hoisted_55, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffsBoarding, (staff, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                staff
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                      _createElementVNode("input", {
                                        value: staff?.name,
                                        disabled: "",
                                        style: {"background":"none"},
                                        type: "text"
                                      }, null, 8, _hoisted_57),
                                      _createVNode(_component_DaIcon, {
                                        class: "ml-4 h-5 w-5 text-blue-600 hover:text-blue-900 active:text-blue-500 cursor-pointer",
                                        name: "das--delete",
                                        onClick: ($event: any) => (_ctx.deleteStaff(index))
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                      _createVNode(_component_Multiselect, {
                                        modelValue: _ctx.staffsBoarding[index],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.staffsBoarding[index]) = $event),
                                        "allow-empty": false,
                                        maxHeight: 140,
                                        options: 
											_ctx._staffs?.map((s) => {
												return {
													nameSearch: _ctx.toEnglish(
														s?.name
													),
													...s,
												};
											})
										,
                                        searchable: true,
                                        "deselect-label": "Đã chọn",
                                        label: "nameSearch",
                                        placeholder: `Chọn ${_ctx.$filters.terminology('teacher')}`,
                                        selectLabel: "",
                                        "track-by": "id"
                                      }, {
                                        noResult: _withCtx(() => [
                                          _createTextVNode(" Không tìm thấy kết quả ")
                                        ]),
                                        option: _withCtx((props) => [
                                          _createElementVNode("div", null, _toDisplayString(props.option.name), 1)
                                        ]),
                                        singleLabel: _withCtx(({ option }) => [
                                          _createElementVNode("div", null, _toDisplayString(option.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder"]),
                                      _createVNode(_component_DaIcon, {
                                        class: "ml-4 h-5 w-5 text-blue-600 hover:text-blue-900 active:text-blue-500 cursor-pointer",
                                        name: "das--delete",
                                        onClick: _ctx.addStaff
                                      }, null, 8, ["onClick"])
                                    ]))
                              ]))
                            }), 128)),
                            _createElementVNode("div", null, [
                              _createElementVNode("button", {
                                class: "button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit",
                                type: "button",
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addStaff && _ctx.addStaff(...args)))
                              }, " Thêm " + _toDisplayString(_ctx.$filters.terminology('teacher')), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.mode === _ctx.actions.CREATE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("input", {
                                  value: 
											_ctx.daysOfWeekFormat([
												..._ctx.defaultWorkingDays,
												..._ctx.boarding.working_days,
											])
										,
                                  disabled: "",
                                  type: "text"
                                }, null, 8, _hoisted_65)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (index) => {
                                return _createElementVNode("div", {
                                  key: index,
                                  class: _normalizeClass([
										_ctx.defaultWorkingDays.includes(index)
											? 'cursor-not-allowed'
											: 'cursor-pointer'
									, "flex items-center w-fit"]),
                                  onClick: ($event: any) => (_ctx.check(index))
                                }, [
                                  _createVNode(_component_Checkbox, {
                                    disabled: 
											_ctx.defaultWorkingDays.includes(index)
										,
                                    value: 
											[
												..._ctx.defaultWorkingDays,
												..._ctx.boarding.working_days,
											].includes(index)
										
                                  }, null, 8, ["disabled", "value"]),
                                  (index != 7)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, " T" + _toDisplayString(index + 1), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_69, " CN "))
                                ], 10, _hoisted_67)
                              }), 64))
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("button", {
              class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
            }, " Thoát "),
            (_ctx.org_setting.allow_create_day_care_class)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button-p text-center whitespace-nowrap",
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, " Lưu và thoát "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}